export const USER_ROLE_CUSTOMER = 'customer';
export const USER_ROLE_PROVIDER = 'provider';

export const isCustomer = userRole => userRole === USER_ROLE_CUSTOMER;

export const isProvider = userRole => userRole === USER_ROLE_PROVIDER;
